import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.sleep.blog.heading',
		defaultMessage: 'More sleep resources on our blog.',
		description: 'Heading for a list of blog posts about sleep.',
	},
});
